export default "__VITE_ASSET__Cs62GiF7__"